import {reportTimeType, ReportTimeType} from "@ots-frontend/ots-data";
import {FormattedDateTime} from "../FormattedDateTime/FormattedDateTime";
import {FormattedDateTimeRange} from "../FormattedDateTimeRange/FormattedDateTimeRange";

interface Props {
  reportTimeType?: ReportTimeType
  fromDate: Date | number | undefined;
  toDate?: Date | number | undefined;
}

const getMonthDateTimeFormat = (): Intl.DateTimeFormat => {
  return new Intl.DateTimeFormat(undefined, {
    month: "long",
    day: undefined,
    year: "numeric",
    hour: undefined,
    minute: undefined,
    second: undefined
  })
}

export const FormattedActivityPeriodDate = (props: Props) => {
  const {reportTimeType: type, fromDate, toDate} = props;

  if ((!type || type === reportTimeType.daily) && fromDate) {
    return (
      <FormattedDateTime date={fromDate}/>
    );
  } else if (
    type === reportTimeType.weekly &&
    fromDate &&
    toDate
  ) {
    return (
      <FormattedDateTimeRange
        start={fromDate}
        end={toDate}
      />
    );
  } else if (type === reportTimeType.monthly && fromDate) {
    const format = getMonthDateTimeFormat()
    return (
      <>
        {format.format(fromDate)}
      </>
    );
  } else {
    return <></>
  }
};
